import { useRef, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { saveToGlobalState } from "../../utils/localStorage";
import { useAuth } from "../../context/AuthContext";

const API_URL = process.env.REACT_APP_API_URL;

const STORAGE_KEY = "confirmation_token";

const CHECK_AVAILABILITY_URL = `${API_URL}/api/users/check-availability/`;

const initialForm = {
  nome: "",
  email: "",
  data_nascimento: "",
  telefone: "",
  cpf: "",
  tipo_pix: "",
  chave_pix: "",
  senha: "",
  repetir_senha: "",

  google_sub: "",
  cadastro_google: false,

  facebook_sub: "",
  cadastro_facebook: false,
};

export default function UseCadastroUsuario() {
  const navigate = useNavigate();
  const location = useLocation();
  const googlePrefill = localStorage.getItem("google_prefill");
  const facebookPrefill = localStorage.getItem("facebook_prefill");

  const prefill =
    location.state ||
    (googlePrefill
      ? JSON.parse(googlePrefill)
      : facebookPrefill
        ? JSON.parse(facebookPrefill)
        : {});
  const [form, setForm] = useState({
    ...initialForm,

    nome: prefill.nome || "",
    email: prefill.email || "",

    google_sub: prefill.google_sub || "",
    cadastro_google: !!prefill.google_sub,

    facebook_sub: prefill.facebook_sub || "",
    cadastro_facebook: !!prefill.facebook_sub,
  });
  const [fieldErrors, setFieldErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [fileName, setFileName] = useState("");
  const [filePreview, setFilePreview] = useState("");
  const [file, setFile] = useState(null);
  const [modalError, setModalError] = useState("");
  const [modalSuccess, setModalSuccess] = useState("");

  const { setShowLoginModal } = useAuth();

  const fileInputRef = useRef(null);
  const isSocialCadastro = !!form.cadastro_google || !!form.cadastro_facebook;

  useEffect(() => {
    return () => {
      if (filePreview) {
        URL.revokeObjectURL(filePreview);
      }
    };
  }, [filePreview]);

  useEffect(() => {
    if (prefill.google_incompleto || prefill.facebook_incompleto) {
      setShowLoginModal(false);
      setModalError("Complete o cadastro!");
    }
  }, [prefill.google_incompleto, setShowLoginModal]);

  const cleanCPF = (value) => value.replace(/\D/g, "");

  const maskDate = (value) => {
    value = value.replace(/\D/g, "");
    value = value.slice(0, 8);
    value = value.replace(/(\d{2})(\d)/, "$1/$2");
    value = value.replace(/(\d{2})(\d)/, "$1/$2");
    return value;
  };

  const maskCPF = (value) => {
    if (!value) return "";
    value = value.replace(/\D/g, "");
    value = value.slice(0, 11);
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    return value;
  };

  const validateCPF = (cpf) => {
    cpf = cpf.replace(/\D/g, "");

    if (cpf.length !== 11) return false;
    if (/^(\d)\1+$/.test(cpf)) return false;

    let sum = 0;
    let rest;

    for (let i = 1; i <= 9; i++) {
      sum += parseInt(cpf.substring(i - 1, i)) * (11 - i);
    }

    rest = (sum * 10) % 11;
    if (rest === 10 || rest === 11) rest = 0;
    if (rest !== parseInt(cpf.substring(9, 10))) return false;

    sum = 0;
    for (let i = 1; i <= 10; i++) {
      sum += parseInt(cpf.substring(i - 1, i)) * (12 - i);
    }

    rest = (sum * 10) % 11;
    if (rest === 10 || rest === 11) rest = 0;
    if (rest !== parseInt(cpf.substring(10, 11))) return false;

    return true;
  };

  const validateEmail = (email) => {
    const value = email.trim();

    if (!value) return "Email é obrigatório";

    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(value)) return "Email inválido";

    return "";
  };

  const validatePhone = (phone) => {
    const digits = phone.replace(/\D/g, "");

    if (!digits) return "Telefone é obrigatório";
    if (digits.length < 10 || digits.length > 11) return "Telefone inválido";

    return "";
  };

  const validatePassword = (password) => {
    if (!password) return "Senha é obrigatória";
    if (password.length < 8) return "Senha deve ter pelo menos 8 caracteres";
    if (!/[A-Z]/.test(password)) return "Senha deve conter 1 letra maiúscula";
    if (!/[a-z]/.test(password)) return "Senha deve conter 1 letra minúscula";
    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]/.test(password)) {
      return "Senha deve conter um símbolo";
    }

    return "";
  };

  const validateRepeatPassword = (password, repeatPassword) => {
    if (!repeatPassword) return "Confirmação de senha é obrigatória";
    if (password !== repeatPassword) return "As senhas não coincidem";
    return "";
  };

  const validateBirthDate = (dateStr) => {
    if (!dateStr || dateStr.length !== 10) {
      return "Data de nascimento inválida";
    }

    const [dd, mm, yyyy] = dateStr.split("/");
    const birthDate = new Date(`${yyyy}-${mm}-${dd}T00:00:00`);

    if (isNaN(birthDate.getTime())) {
      return "Data de nascimento inválida";
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    birthDate.setHours(0, 0, 0, 0);

    if (birthDate >= today) {
      return "Data de nascimento inválida";
    }

    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    const finalAge =
      monthDiff < 0 || (monthDiff === 0 && dayDiff < 0) ? age - 1 : age;

    if (finalAge < 18) {
      return "Você precisa ter pelo menos 18 anos";
    }

    return "";
  };

  const validateCpfField = (cpf) => {
    const raw = cpf.replace(/\D/g, "");
    if (!raw) return "CPF é obrigatório";
    if (raw.length !== 11) return "CPF inválido";
    return validateCPF(raw) ? "" : "CPF inválido";
  };

  const normalizeError = (value) => {
    if (!value) return null;

    const item = Array.isArray(value) ? value[0] : value;
    if (!item) return null;
    if (typeof item === "string") return item;

    return item.message || item.detail || item.code || null;
  };

  const checkAvailability = async (field, value) => {
    if (!API_URL) return "";

    try {
      const response = await fetch(
        `${CHECK_AVAILABILITY_URL}?field=${encodeURIComponent(
          field,
        )}&value=${encodeURIComponent(value)}`,
      );

      if (!response.ok) return "";

      const data = await response.json();

      const exists =
        data?.exists === true ||
        data?.taken === true ||
        data?.available === false;

      if (!exists) return "";

      if (field === "email") return data?.message || "Email já cadastrado";
      if (field === "cpf") return data?.message || "CPF já cadastrado";
      if (field === "telefone")
        return data?.message || "Telefone já cadastrado";
      if (field === "chave_pix")
        return data?.message || "Chave pix já cadastrado";

      return data?.message || "Já existe um cadastro com esse valor";
    } catch {
      return "";
    }
  };

  const syncPasswordErrors = (nextForm) => {
    setFieldErrors((prev) => {
      const next = { ...prev };

      const passwordError = validatePassword(nextForm.senha);
      if (passwordError) {
        next.senha = passwordError;
      } else if (next.senha && next.senha === "Senha é obrigatória") {
        next.senha = "";
      }

      if (!nextForm.senha || !nextForm.repetir_senha) {
        next.repetir_senha = "";
      } else {
        const repeatError = validateRepeatPassword(
          nextForm.senha,
          nextForm.repetir_senha,
        );

        next.repetir_senha = repeatError;
      }

      return next;
    });
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));

    setFieldErrors((prev) => ({
      ...prev,
      [field]: "",
    }));

    if (field === "senha" || field === "repetir_senha") {
      setTimeout(() => {
        setForm((current) => {
          syncPasswordErrors({
            ...current,
            [field]: value,
          });

          return current;
        });
      }, 0);
    }
  };

  const validateField = async (field) => {
    let message = "";

    switch (field) {
      case "nome":
        message = form.nome.trim() ? "" : "Nome é obrigatório";
        break;

      case "email":
        message = validateEmail(form.email);
        if (!message) {
          const availabilityError = await checkAvailability(
            "email",
            form.email.trim(),
          );
          message = availabilityError;
        }
        break;

      case "data_nascimento":
        message = validateBirthDate(form.data_nascimento);
        break;

      case "telefone":
        message = validatePhone(form.telefone);
        if (!message) {
          const availabilityError = await checkAvailability(
            "telefone",
            form.telefone,
          );
          message = availabilityError;
        }
        break;

      case "cpf":
        message = validateCpfField(form.cpf);
        if (!message) {
          const availabilityError = await checkAvailability(
            "cpf",
            cleanCPF(form.cpf),
          );
          message = availabilityError;
        }
        break;

      case "tipo_pix":
        message = form.tipo_pix.trim() ? "" : "Tipo PIX é obrigatório";
        break;

      case "chave_pix":
        message = form.chave_pix.trim() ? "" : "Chave PIX é obrigatória";
        if (!message) {
          const availabilityError = await checkAvailability(
            "chave_pix",
            form.chave_pix.trim(),
          );
          message = availabilityError;
        }
        break;

      case "senha":
        message = validatePassword(form.senha);
        break;

      case "repetir_senha":
        message = validateRepeatPassword(form.senha, form.repetir_senha);
        break;

      default:
        break;
    }

    setFieldErrors((prev) => ({
      ...prev,
      [field]: message,
    }));

    return message;
  };

  const handleCpfChange = (value) => {
    const masked = maskCPF(value);
    handleChange("cpf", masked);
  };

  const handleDateChange = (value) => {
    handleChange("data_nascimento", maskDate(value));
  };

  const handlePhoneChange = (value) => {
    let raw = value.replace(/\D/g, "");
    if (raw.length > 11) raw = raw.slice(0, 11);

    raw = raw.replace(/^(\d{2})(\d)/, "($1) $2");
    raw = raw.replace(/(\d{5})(\d)/, "$1-$2");

    handleChange("telefone", raw);
  };

  const openFilePicker = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files?.[0];

    if (!selectedFile) return;

    setFile(selectedFile);
    setFileName(selectedFile.name);

    const previewURL = URL.createObjectURL(selectedFile);
    setFilePreview(previewURL);
  };

  const brDateToIso = (dateBR) => {
    const [dd, mm, yyyy] = dateBR.split("/");
    if (!dd || !mm || !yyyy) return "";
    return `${yyyy}-${mm}-${dd}`;
  };

  const resetForm = () => {
    localStorage.removeItem("google_prefill");
    localStorage.removeItem("facebook_prefill");

    setForm(initialForm);

    setFieldErrors({});
    setFile(null);
    setFilePreview("");
    setFileName("");
    setModalError("");
    setModalSuccess("");

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const validateForm = async () => {
    const fieldsToValidate = [
      "nome",
      "email",
      "data_nascimento",
      "telefone",
      "cpf",
      "tipo_pix",
      "chave_pix",
    ];

    if (!isSocialCadastro) {
      fieldsToValidate.push("senha", "repetir_senha");
    }

    for (const field of fieldsToValidate) {
      const error = await validateField(field);
      if (error) return error;
    }

    if (!file) {
      return "Envie uma imagem de identificação";
    }

    return null;
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      setModalError("");
      setModalSuccess("");

      const error = await validateForm();
      if (error) {
        setModalError(error);
        setLoading(false);
        return;
      }

      const payload = new FormData();

      payload.append("nome", form.nome);
      payload.append("email", form.email);
      payload.append("data_nascimento", brDateToIso(form.data_nascimento));
      payload.append("telefone", form.telefone);
      payload.append("cpf", cleanCPF(form.cpf));
      payload.append("tipo_pix", form.tipo_pix);
      payload.append("chave_pix", form.chave_pix);
      payload.append(
        "cadastro_google",
        form.cadastro_google ? "true" : "false",
      );
      payload.append("google_sub", form.google_sub || "");
      payload.append(
        "cadastro_facebook",
        form.cadastro_facebook ? "true" : "false",
      );

      payload.append("facebook_sub", form.facebook_sub || "");

      if (!isSocialCadastro) {
        payload.append("password", form.senha);
      }

      if (file) {
        payload.append("identificacao", file);
      }

      const response = await fetch(`${API_URL}/api/users/`, {
        method: "POST",
        body: payload,
      });

      const data = await response.json();

      if (!response.ok) {
        const errorMessage =
          normalizeError(data?.email) ||
          normalizeError(data?.cpf) ||
          normalizeError(data?.telefone) ||
          normalizeError(data?.chave_pix) ||
          normalizeError(data?.data_nascimento) ||
          normalizeError(data?.password) ||
          normalizeError(data?.identificacao) ||
          normalizeError(data?.detail) ||
          "Erro ao cadastrar usuário";

        setModalError(errorMessage);
        setLoading(false);
        return;
      }

      const email = form.email;
      const telefone = form.telefone;

      if (data?.confirmation_token) {
        saveToGlobalState({
          [STORAGE_KEY]: data.confirmation_token,
        });
      }

      setModalSuccess("Usuário cadastrado com sucesso!");
      resetForm();
      setLoading(false);

      navigate("/confirmacao-email", {
        state: { email, telefone, phone_confirmation: false },
      });
    } catch (err) {
      setModalError("Erro de conexão com o servidor");
      setLoading(false);
    }
  };

  return {
    form,
    fieldErrors,
    loading,
    fileName,
    filePreview,
    fileInputRef,
    handleChange,
    handlePhoneChange,
    handleCpfChange,
    handleDateChange,
    handlePhoneChange,
    handleFileChange,
    openFilePicker,
    handleSubmit,
    validateField,
    modalError,
    modalSuccess,
    setModalError,
    setModalSuccess,
    isSocialCadastro,
  };
}
